import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer px-4 mx-2" }
const _hoisted_2 = { class: "row align-items-center justify-content-lg-between" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-4\"><div class=\"copyright text-center text-lg-left text-muted\"> © copyright 2021 <a href=\"\" class=\"font-weight-bold ml-1\" target=\"_blank\"> Experience Model Labs </a></div><div class=\"copyright text-center text-lg-left text-muted\"> All rights reserved. </div></div><div class=\"col-lg-4\"><ul class=\"nav nav-footer justify-content-center\"><a class=\"nav-item mx-2\" href=\"https://www.facebook.com/profile.php?id=61558876857002\" target=\"_blank\"><i class=\"fab fa-facebook\"></i></a><a class=\"nav-item mx-2\" href=\"https://www.facebook.com/profile.php?id=61558876857002\" target=\"_blank\"><i class=\"fab fa-instagram\"></i></a></ul></div>", 2)
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "nav nav-footer justify-content-center justify-content-lg-end" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  target: "_blank"
}, " Call Center ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  target: "_blank"
}, " Omnichannel ", -1)
const _hoisted_12 = [
  _hoisted_11
]

import { env } from "@/config";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const year = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_unref(env).requiredCallcenter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (!_unref(env).onlyCallcenter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})